import store from '..'
import axios from 'axios'
import API from '@/common/api'
import LANG from '@/common/lang'
import moment from 'moment/moment'

export default {
  namespaced: true,
  state: {
    coupon: [],
    setInfo: {
      title: '',
      category: [],
      useAfter: new Date().toISOString(),
      useBefore: moment().add(1, 'day').toISOString(),
      payload: {
        useTerm: false,
        text1: LANG.valueObj(),
        text2: LANG.valueObj(),
        image: null,
        barcode: false,
        barcodeType: 'undefined',
        barcodeValue: ''
      }
    },
    category: [],
    preview: {
      isPreview: false,
      lang: LANG.default
    }
  },
  mutations: {
    couponData (state, data) {
      state.coupon = data
    },
    initSetInfo (state) {
      state.setInfo = {
        title: '',
        category: [],
        useAfter: new Date().toISOString(),
        useBefore: moment().add(1, 'day').toISOString(),
        payload: {
          useTerm: false,
          text1: LANG.valueObj(),
          text2: LANG.valueObj(),
          image: null,
          barcode: false,
          barcodeType: 'undefined',
          barcodeValue: ''
        }
      }
    },
    setPreview (state, data) {
      const key = Object.keys(data)
      key.forEach(function (x, i) {
        state.preview[x] = data[x]
      })
    },
    setCouponInfo (state, data) {
      state.setInfo = Object.assign(state.setInfo, data)
    },
    setCategory (state, data) {
      data = !data ? [] : data
      state.category = data
    }
  },
  actions: {
    addCoupon ({ state }, data) {
      state.coupon.unshift(data)
      return true
    },
    async getCouponList ({ commit }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_ALL_COUPON_PARAMS,
          id: store.state.authentication.requestId,
          siteid: store.state.authentication.userInfo.siteid,
          from: '2019-01-01T00:00:00Z',
          to: moment().add(1, 'day').toISOString()
        })
        commit('couponData', res.data.message)
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    setCouponData ({ state }, data) {
      const setData = {}
      Object.keys(data).forEach(function (x) {
        setData[x] = JSON.stringify(data[x])
      })
      return setData
    },
    async createCoupon ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.CREATE_COUPON_PARAMS,
          id: store.state.authentication.requestId,
          ...data
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async updateCoupon ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.UPDATE_COUPON_PARAMS,
          id: store.state.authentication.requestId,
          ...data
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async delCoupon ({ state, dispatch }, cid) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.DEL_COUPON_PARAMS,
          id: store.state.authentication.requestId,
          cid: cid
        })
        return res.data.message
      } catch (ex) {
        // console.error('error:', ex)
        alert(ex)
        console.log(ex)
        return ex.response.data.message
      }
    },
    async getCategory ({ state, dispatch, commit }) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_COUPON_CATEGORY_PARAMS,
          id: store.state.authentication.requestId
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setCategory ({ state }) {
      const data = state.category
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_COUPON_CATEGORY_PARAMS,
          id: store.state.authentication.requestId,
          data: data
        })
        return res.data.message
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    }
  },
  getters: {
    coupon (state) {
      return state.coupon
    },
    getSetInfo (state) {
      return state.setInfo
    },
    getCategory (state) {
      return state.category
    }
  }
}
